import {use} from 'react'

import {type BoardHeadingElementLevel, BoardHeadingLevelsContext} from '../provider/contexts'

/**
 * The heading level a card should use if it decides to render a heading, resolved by `BoardProvider`
 * from `headingLevel` and `hasRowHeaders`. Cards may choose to not render a heading, but any that
 * do read its level here rather than hard-coding one.
 *
 * Returns the outside-provider default (`3`) so a card rendered on its own in a story
 * still produces a valid heading.
 */
export function useBoardCardHeadingLevel(): BoardHeadingElementLevel {
  return use(BoardHeadingLevelsContext)?.card ?? 3
}
